import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { NotificationsService } from '@asambleas-services/notifications/notifications.service';
import { Notification } from '@asambleas-models/notification.model';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

    notifications: Array<Notification> = [];
    resourcesHasLoaded: boolean = false;

    constructor(
        private _notificationsService: NotificationsService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this._notificationsService.getNotifications().subscribe((data: Array<any>) => {
            data.forEach(element => {
                const n = new Notification(element);
                this.notifications.push(n)
            });
            this.notifications.reverse();
            this.resourcesHasLoaded = true;
        })
    }

    notificationRead(id: number) {
        this._notificationsService.notificacionRead(id)
            .subscribe((data) => {

                this._notificationsService.notificacionWasRead.emit(true);

                this.snackBar.open('Notificación eliminada', 'Cerrar', {
                    duration: 3000
                });

                for (let i = 0; i < this.notifications.length; i++) {
                    if (this.notifications[i].id == id) {
                        this.notifications.splice(i, 1);
                    }
                }

            })
    }

    respondRequest(n: Notification) {
        console.log(n)
        this._notificationsService.processRequestNotification(n)
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/notifications/notifications.component.ts